<template>
    <el-form-item class="w-100" :label="label" label-position="top" :prop="prop">
        <el-input-number
            class="w-100"
            v-model="localInput"
            size="large"
            :placeholder="placeholder"
            @input="updateValue"
            controls-position="right"
        >
            <template #prefix>
                <i :class="'text-primary ti ti-' + icon"></i>
            </template>
        </el-input-number>
    </el-form-item>
</template>

<script lang="ts" setup>
    import { ref, watch } from 'vue'

    const props = defineProps({
        modelValue: {
            type: [String, Number, null],
            required: true,
        },
        prop: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'pencil',
        },
        label: {
            type: String,
            required: true,
        },
    })

    const emit = defineEmits(['update:modelValue'])

    const localInput = ref(props.modelValue)

    watch(
        () => props.modelValue,
        newValue => {
            localInput.value = newValue
        }
    )

    const updateValue = (value: string) => {
        localInput.value = value
        emit('update:modelValue', value)
    }
</script>
